import { Copy } from "lucide-react";
import { toast } from "sonner";
import { formatJsonContent } from "@/lib/json";

interface CopyableJsonBlockProps {
  label: string;
  value: unknown;
  tone?: "default" | "error";
}

export const CopyableJsonBlock = ({ label, value, tone = "default" }: CopyableJsonBlockProps) => {
  const formatted = formatJsonContent(value);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(formatted);
      toast.success("Copied to clipboard");
    } catch {
      toast.error("Failed to copy to clipboard");
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-semibold text-genie-text-primary">{label}</h4>
        <button
          onClick={handleCopy}
          className="p-1 text-genie-text-muted hover:text-genie-text-primary hover:bg-genie-background-muted rounded transition-colors"
          aria-label={`Copy ${label}`}
        >
          <Copy className="h-3.5 w-3.5" />
        </button>
      </div>
      <pre
        className={`bg-white p-3 rounded text-xs overflow-auto max-h-96 font-mono border border-genie-border break-words whitespace-pre-wrap ${
          tone === "error" ? "text-genie-error" : "text-genie-text-primary"
        }`}
      >
        {formatted}
      </pre>
    </div>
  );
};
